var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

import view from '../mixins/view';
export default {
  name: 'SelectPageTable',
  mixins: [view],
  props: {
    tbColumns: Array
  },
  render: function render(h) {
    var _this = this;

    return h('table', { class: 'sp-table' }, [
    // table thead
    h('thead', [h('tr', {
      class: { 'sp-rtl': this.rtl }
    }, this.tbColumns.map(function (val) {
      return h('th', val.title);
    }))]),
    // table tbody
    h('tbody', {
      on: {
        mouseleave: function mouseleave() {
          return _this.highlight(-1);
        }
      }
    }, this.list.map(function (val, index) {
      // table row
      return h('tr', {
        key: index,
        class: _this.rowClass(val, index),
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.rowClick(val);
          },
          mouseenter: function mouseenter() {
            return _this.highlight(_this.inPicked(val) ? -1 : index);
          }
        }
      }, _this.tbColumns.map(function (col, idx) {
        // table cells
        return h('td', {
          key: idx,
          domProps: {
            innerHTML: _this.renderColumn(val, col)
          }
        });
      }));
    }))]);
  },

  methods: {
    renderColumn: function renderColumn(row, col) {
      if (!row || !Object.keys(row).length || !col || !col.data) return '';
      switch (_typeof(col.data)) {
        case 'string':
          return row[col.data];
        case 'function':
          return col.data(row);
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/components/Table.js
// module id = 15
// module chunks = 0